var _defs, _line, _polyline, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalOutdoorTemp = function SvgPSignalOutdoorTemp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684.2 480.2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.1,
    y1: 55.1,
    x2: 18.1,
    y2: 46.1,
    fill: "none",
    stroke: "#1c9d5b",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "342.1 46.1 342.1 55.1 17.1 55.1",
    fill: "none",
    stroke: "#1c9d5b",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 18.6,
    width: 27,
    height: 27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1,19.1v26H5.1v-26h26M32.1,18.1H4.1v28h28v-28h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 20.8,
    width: 3.9,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 23.9,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 27,
    width: 3.9,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 30.2,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 33.3,
    width: 3.9,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "13.5 26.4 13.5 26.3 13.4 26.2 13.5 26.4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,35.3v-13.8h-3.8v13.8c-1.2.7-2,2-2,3.4,0,2.2,1.8,3.9,3.9,3.9s3.9-1.8,3.9-3.9c0-1.4-.8-2.7-2-3.4h0ZM16.1,41.5c-1.5,0-2.8-1.2-2.8-2.8,0-1.1.6-2.1,1.6-2.5v-5.6h2.4v5.6c.9.5,1.6,1.4,1.6,2.5,0,1.6-1.2,2.8-2.8,2.8h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,36.2v-5.6h-2.4v5.6c-.9.5-1.6,1.4-1.6,2.5,0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8c-.1-1.1-.7-2-1.6-2.5h0ZM17.5,40.1l-.5-.5c.2-.2.4-.5.4-.8s-.1-.6-.4-.8l.5-.5c.4.4.6.8.6,1.4s-.2.8-.6,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,34.9v-14.1h-5.3v14.1c-1.2.8-2,2.2-2,3.8,0,2.6,2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7c-.1-1.5-.9-3-2.1-3.8h0ZM16.1,42.7c-2.2,0-3.9-1.8-3.9-3.9,0-1.5.8-2.8,2-3.4v-13.9h3.8v13.8c1.2.7,2,2,2,3.4.1,2.2-1.7,4-3.9,4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,37.9c.2.2.4.5.4.8s-.1.6-.4.8l.5.5c.4-.4.6-.8.6-1.4s-.2-1-.6-1.4l-.5.7Z",
    fill: "#fff"
  }))))));
};
export default SvgPSignalOutdoorTemp;